<div [hidden]="consulta" class="evaluacion">
    <div class="row" >
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{titulo}} </h3>
                    <div class="separador"></div>
                    <div class="divisor8"></div>
                    <div class="row">
                        <div  class="col-lg-4 col-md-4 col-sm-12 col-12">
                            <inputCustom [titulo]="'Persona a evaluar'"
                                [(ngModel)]="entidad.nombre"
                                [disabled]="true"></inputCustom>
                            <inputCustom [titulo]="'Periodo'"
                                [(ngModel)]="entidad.periodoevaluacion"
                                [disabled]="true"></inputCustom>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                            <inputCustom [titulo]="'Puesto'"
                                [(ngModel)]="entidad.puesto"
                                [disabled]="true"></inputCustom>
                            <inputCustom [titulo]="'Departamento'"
                                [(ngModel)]="entidad.departamento"
                                [disabled]="true"></inputCustom>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                            <div *ngIf="entidad.urlfotografia">
                                <div class="imagencolaborador">
                                    <imagenVisualizador [imagen]="entidad.urlfotografia"  [verCompleta]="false" [alineacion]="AlineacionImagenEnum.ScaleToFill"></imagenVisualizador>
                                </div>
                        </div>
                        </div>


                    </div>
                </header>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <evaluacion *ngIf="listapreguntas.length > 0"
        [listapreguntas]="listapreguntas"
        [objobservacion]="objobservacion"
        [tipovisualizacioncompetenciacriterio]="entidad.tipovisualizacioncompetenciacriterioid"
        [tipovisualizacionpregunta]="entidad.tipovisualizacionpreguntaid"
        [tipovisualizacionrespuesta]="entidad.tipovisualizacionrespuestaid"
        (sinterminar)="sinterminar()"
        (terminado)="terminado()"
        (comentario)="guardarcomentario($event)"
        (guardarrespuesta)="guardarrespuesta($event)"
        ></evaluacion>
</div>
